import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import actions from './../actions';
import React, { Component } from "react";
import {Redirect} from "react-router-dom"


class LoginTokenContainer extends Component {

    componentWillMount() {
        if (this.props.token) {
            this.props.login({
                token: this.props.token,
                adfsEntity: this.props.adfsEntity
            });
        }
    }

    render() {

        if (this.props.userLoggedIn) {
            return <Redirect to="/dashboard" />
        }
        else if (!this.props.token || this.props.loginError) {
            return <Redirect to="/auth" />
        }

        return <div>Loading...</div>
    }
}

LoginTokenContainer.propTypes = {
    login: PropTypes.func.isRequired
};

const mapStateToProps = ({ authReducer }) => ({
    loginError: authReducer.loginError,
    userLoggedIn: authReducer.userLoggedIn,
    user: authReducer.user,
});

const mapDispatchToProps = {
    login: actions.login,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginTokenContainer)
